export default function About(props) {
  return (
    <div className={`${props.mode === 'dark' ? 'bg-dark text-light' : ''} py-5`}>

      {/* Heading */}
      <div id="about" className="madimi-one-regular text-center content-heading-text mb-4">
        About Me
      </div>

      <hr className="w-50 m-auto mb-5" />

      <section className="container">

        {/* TOP SECTION */}
        <div className="row align-items-center g-4">

          {/* PROFILE IMAGE */}
          <div className="col-12 col-md-4 text-center">
            <img
              src="2.jpg"
              alt="profile"
              className="img-fluid rounded-circle shadow"
              style={{ width: "300px", height: "320px", objectFit: "cover" }}
              data-aos="flip-right"
              data-aos-duration="2000"
            />
          </div>

          {/* ABOUT TEXT */}
          <div className="col-12 col-md-8">
            <p className="text-justify mb-0">
              Hello, I’m <strong>Sugam Neupane</strong>, a NodeJS Backend Developer with 1+ year of experience working with NestJS, TypeORM, Node.js, PostgreSQL and MongoDB building scalable and production-ready systems.
              <br /><br />

              I specialize in designing and developing backend modules for real-world applications, focusing on clean architecture, performance optimization, and maintainable codebases.
              I have worked closely with stakeholders and clients to translate operational requirements into functional product features.
              <br /><br />

              <b>Experience highlights:</b><br />
              • Designed and developed backend modules for a procurement management platform using NestJS and PostgreSQL<br />
              • Collaborated with clients and internal teams to refine workflows and deliver business-aligned solutions<br />
              • Developed features for the Ministry of Law, Justice and Parliamentary Affairs (MOLJPA) government website using EJS<br />
              • Optimized database performance using TypeORM, indexing, and PostgreSQL materialized views<br />
              • Worked on legacy systems, SSR-based applications, and frontend integration issues<br />
              <br />

              I enjoy building systems that solve real problems and improve workflows at scale. I’m currently open to opportunities where I can contribute as a backend or full-stack developer in a fast-paced environment.
            </p>
          </div>

        </div>

        {/* CTA + GITHUB SECTION */}
        <div className="row align-items-center mt-2 g-5">

          {/* LEFT SIDE */}
          <div className="col-12 col-md-6 px-md-4">

            {/* TITLE */}
            <div className="text-center mb-3">
              <h5 className="mb-0">
                <b>Let’s build something meaningful together.</b>
              </h5>
            </div>

            {/* SOCIAL ICONS */}
            <div className="d-flex justify-content-center flex-wrap mb-3">

              <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'primary'} btn-floating m-1`}
                href="https://www.facebook.com/ns.neupane09/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi-facebook"></i>
              </a>

              <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'danger'} btn-floating m-1`}
                href="https://www.instagram.com/ns_neupane09"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi-instagram"></i>
              </a>

              <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'primary'} btn-floating m-1`}
                href="https://www.linkedin.com/in/sugamneupane/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi-linkedin"></i>
              </a>

              <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'dark'} btn-floating m-1`}
                href="https://github.com/NSugam"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi-github"></i>
              </a>

            </div>

            {/* ACTION BUTTONS */}
            <div className="d-flex justify-content-center flex-wrap gap-2">

              <a
                className={`btn btn-${props.mode === 'dark' ? 'light' : 'success'}`}
                href="https://drive.google.com/file/d/1OfhdfY5wfwfz_mg5Vp6VXge7G-A_q7wt/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                My Resume
              </a>

              <a
                className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'success'}`}
                href="#contact"
              >
                Get in touch!
              </a>

            </div>

          </div>

          {/* RIGHT SIDE - GITHUB STATS */}
          <div className="col-12 col-md-6 px-md-4 text-center">

            {/* {props.isDesktop && ( */}
            <a href="https://github.com/NSugam" target="_blank" rel="noopener noreferrer">
              <img
                className="img-fluid"
                style={{ maxWidth: "100%" }}
                src={`https://github-stats.neupanesugam.com.np?user=NSugam&theme=${props.mode === 'dark' ? 'dark' : ''}&hide_border=${props.mode === 'dark'}&border_radius=10`}
                alt="GitHub Stats"
              />
            </a>
            {/* )} */}

          </div>

        </div>

      </section>
    </div>
  );
}